import { c as _c } from "react/compiler-runtime";
import { causeMeta } from './Causes';
import { ChartMeta, EditCfgSchema } from './chartMeta.types';
import { match } from 'ts-pattern';
import { useQuery } from '@tanstack/react-query';
import { conditionalsMeta } from './conditionals';
import { consequencesMeta } from './Consequences';
import { forecastBarMeta } from './Bars';
import { ChartType } from './charts';
import { simpleBarsMeta } from './simpleBars';
export const unknownMeta: ChartMeta = {
  title: '',
  type: 'Unknown',
  View: () => null,
  edit: {
    initial: () => ({}),
    cfgSchema: {},
    cfgToProps: () => ({}),
    parser: {}
  }
};
export const getChartMeta = (type?: ChartType) => match(type).with('Conditionals', () => conditionalsMeta).with('SimpleBars', () => simpleBarsMeta).with('Consequences', consequencesMeta).with('ForecastBar', () => forecastBarMeta).with('CauseBars', causeMeta).otherwise(() => unknownMeta) as ChartMeta;
export const defaultChartSchema: EditCfgSchema = {
  title: {
    label: 'Title',
    style: {
      width: '30em'
    }
  },
  source: {
    label: 'Source'
  }
};
export const useChartMeta = type => {
  const $ = _c(2);
  let t0;
  if ($[0] !== type) {
    t0 = {
      queryKey: ["meta", type],
      queryFn: async () => getChartMeta(type)
    };
    $[0] = type;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data
  } = useQuery(t0);
  return data ?? unknownMeta;
};